import { pathToVariant } from 'shared/helpers/activateABTest';

export const SMS_OPT_IN_VARIANTS = ['bonobo', 'e'];

export const isSmsOptInVariant = (onboardingBasePath: string): boolean => {
  const variantGroup = onboardingBasePath.includes('tech_onboard')
    ? 'techOnboarding'
    : 'onboarding';
  return SMS_OPT_IN_VARIANTS.includes(
    pathToVariant(onboardingBasePath, variantGroup)
  );
};
